const en = require('./en.json');
const cs = require('./cs.json');
const de = require('./de.json');
// import de from './de.json';

module.exports = { cs, en, de };
